// Codes of Practice PDF Documents Configuration

export const codesPracticeDocuments = [
  // Code of Practice Series
  {
    id: 'cop-1-part-1',
    title: 'Code of Practice 1 - Part 1',
    description: 'Bulk LPG storage at fixed installations',
    filename: 'Code of Practice 1 - Part 1.pdf',
    category: 'Storage'
  },
  {
    id: 'cop-1-part-2',
    title: 'Code of Practice 1 - Part 2',
    description: 'Bulk LPG storage at fixed installations',
    filename: 'Code of Practice 1 - Part 2.pdf',
    category: 'Storage'
  },
  {
    id: 'cop-1-part-3',
    title: 'Code of Practice 1 - Part 3',
    description: 'Bulk LPG storage at fixed installations',
    filename: 'Code of Practice 1 - Part 3.pdf',
    category: 'Storage'
  },
  {
    id: 'cop-1-part-4',
    title: 'Code of Practice 1 - Part 4',
    description: 'Bulk LPG storage at fixed installations',
    filename: 'Code of Practice 1 - Part 4 .pdf',
    category: 'Storage'  
  },
  {
    id: 'cop-2',
    title: 'Code of Practice 2',
    description: 'LPG Cylinders',
    filename: 'Code of Practice 2.pdf',
    category: 'Cylinders'
  },
  {
    id: 'cop-3',
    title: 'Code of Practice 3',
    description: 'Cylinder manifold systems',
    filename: 'Code of Practice 3.pdf',
    category: 'Cylinders'
  },
  {
    id: 'cop-4',
    title: 'Code of Practice 4',
    description: 'LPG pipe work installations',
    filename: 'Code of Practice 4.pdf',
    category: 'Installation'
  },
  {
    id: 'cop-7',
    title: 'Code of Practice 7',
    description: 'Filling of cylinders by weight',
    filename: 'Code of Practice 7.pdf',
    category: 'Operations'
  },
  {
    id: 'cop-9',
    title: 'Code of Practice 9',
    description: 'Training of personnel',
    filename: 'Code of Practice 9.pdf',
    category: 'Training'
  },
  {
    id: 'cop-10',
    title: 'Code of Practice 10',
    description: 'Liquefied petroleum gas test certificates',
    filename: 'Code of Practice 10.pdf',
    category: 'Testing'
  },
  {
    id: 'cop-11',
    title: 'Code of Practice 11',
    description: 'Periodic inspection of LPG cylinders',
    filename: 'Code of Practice 11.pdf',
    category: 'Testing'
  },
  {
    id: 'cop-12',
    title: 'Code of Practice 12',
    description: 'Refillable welded steel gas cylinders',
    filename: 'Code of Practice 12.pdf',
    category: 'Cylinders'
  },
  {
    id: 'cop-17',
    title: 'Code of Practice 17',
    description: 'Avoidance of pollution from LPG',
    filename: 'Code of Practice 17.pdf',
    category: 'Environmental'
  },
  {
    id: 'cop-18',
    title: 'Code of Practice 18',
    description: 'Design, construction and operation of LPG installations',
    filename: 'Code of Practice 18.pdf',
    category: 'Installation'
  },
  {
    id: 'cop-19-part-1',
    title: 'Code of Practice 19 - Part 1',
    description: 'Automotive LPG refuelling stations',
    filename: 'Code of Practice 19 - Part 1.pdf',
    category: 'Automotive'
  },
  {
    id: 'cop-19-part-2',
    title: 'Code of Practice 19 - Part 2',
    description: 'Automotive LPG refuelling stations',
    filename: 'Code of Practice 19 - Part 2.pdf',
    category: 'Automotive'
  },
  {
    id: 'cop-20',
    title: 'Code of Practice 20',
    description: 'Requirements for LPG gas tankers',
    filename: 'Code of Practice 20.pdf',
    category: 'Transport'
  },
  {
    id: 'cop-22',
    title: 'Code of Practice 22',
    description: 'Safe storage and handling of full and empty LPG cylinders',
    filename: 'Code of Practice 22 .pdf',
    category: 'Storage'
  },
  {
    id: 'cop-24-part-3',
    title: 'Code of Practice 24 - Part 3',
    description: 'Periodic inspection of fixed LPG storage vessels',
    filename: 'Code of Practice 24 - Part 3.pdf',
    category: 'Testing'
  },
  {
    id: 'cop-25',
    title: 'Code of Practice 25',
    description: 'Small bulk LPG installations',
    filename: 'Code of Practice 25.pdf',
    category: 'Installation'
  },
  {
    id: 'cop-26',
    title: 'Code of Practice 26',
    description: 'Safe storage and handling of mini-bulk LPG vessels',
    filename: 'Code of Practice 26.pdf',
    category: 'Storage'
  },
  {
    id: 'cop-27',
    title: 'Code of Practice 27',
    description: 'Fire protection at LPG installations',
    filename: 'Code of Practice 27.pdf',
    category: 'Safety'
  },
  {
    id: 'cop-30',
    title: 'Code of Practice 30',
    description: 'Safe operation of LPG road tankers',
    filename: 'Code of Practice 30.pdf',
    category: 'Transport'
  },
  {
    id: 'cop-32',
    title: 'Code of Practice 32',
    description: 'LPG emergency procedures',
    filename: 'Code of Practice 32 .pdf',
    category: 'Emergency'
  },
  {
    id: 'cop-33',
    title: 'Code of Practice 33',
    description: 'Periodic inspection of fixed LPG storage vessels (Replaces COP 24 Parts 1, 5 & 6)',
    filename: 'Code of Practice 33 (Replaces COP 24 Part 1|5|6).pdf',
    category: 'Testing'
  },
  // Guidance Notes
  {
    id: 'gn2',
    title: 'Guidance Note 2',
    description: 'LPG industry guidance note',
    filename: 'GN2.pdf',
    category: 'Guidance'
  },
  {
    id: 'gn3',
    title: 'Guidance Note 3',
    description: 'LPG industry guidance note',
    filename: 'GN3.pdf',
    category: 'Guidance'
  },
  // Superseded Documents
  {
    id: 'cop-24-part-1',
    title: 'Code of Practice 24 - Part 1 (Superseded)',
    description: 'Superseded by COP 33',
    filename: 'Code of Practice 24 - Part 1 (Superseded by COP33).pdf',
    category: 'Storage'
  },
  {
    id: 'cop-24-part-5',
    title: 'Code of Practice 24 - Part 5 (Superseded)',
    description: 'Superseded by COP 33',
    filename: 'Code of Practice 24 - Part 5 (Superseded by COP33).pdf',
    category: 'Storage'
  },
  {
    id: 'cop-24-part-6',
    title: 'Code of Practice 24 - Part 6 (Superseded)',
    description: 'Superseded by COP 33',
    filename: 'Code of Practice 24 - Part 6 (Superseded by COP33).pdf',
    category: 'Storage'
  }
];

// Helper function to get PDF URL
export const getPdfUrl = (filename) => {
  return `/pdfs/codes-of-practice/${filename}`;
};
